import "react";
import { Icon } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { MdAdminPanelSettings } from "react-icons/md";
//#region src/modules/Users/shared/SuperAdminIcon.tsx
function SuperAdminIcon(props) {
	return /* @__PURE__ */ jsx(Icon, {
		className: "text-color-caution",
		Icon: MdAdminPanelSettings,
		...props
	});
}
//#endregion
export { SuperAdminIcon };

//# sourceMappingURL=SuperAdminIcon.js.map